import ResponseErrorHandling from "../../../../helper/ResponseErrorHandling";
import commonService from "../../../../services/Common/service";
import { CommonActionTypes } from "../../../action-types";

export const getTransactionMethods = () => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const res = await commonService.get("/lookups/get-transaction-methods");
    const transferMethods = res.data.data;
    if (transferMethods) {
      localStorage.setItem("transferMethods", JSON.stringify(transferMethods));
    }
    console.log("Transaction Methods:", transferMethods);
    dispatch({ type: CommonActionTypes.GET_TRANSFER_METHODS, payload: transferMethods });
    return transferMethods;
  } catch (err) {
    const message = err.response.data.message || err.message || err.toString();

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};
